import * as React from "react";
import { Context } from "./_context";
export const HelpSimpleIcon = ({ size = 16, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[16] = /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 12.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM8 1.25c2.345 0 4.083 1.779 4.083 4.03 0 1.138-.464 2.08-1.228 2.74-.58.501-1.312.822-2.105.972V11h-1.5V7.629l.703-.044c.803-.05 1.47-.31 1.921-.7.437-.378.709-.907.709-1.605 0-1.42-1.063-2.53-2.583-2.53-1.547 0-2.638 1.141-2.93 2.67l-1.473-.28C3.987 3.093 5.556 1.25 8 1.25Z", fill: "currentColor" }));
  return iconset[size];
};
HelpSimpleIcon.iconId = "nBz2DR";
